import React, { useState, useEffect } from "react";
import Topbar from "../../components/Topbar";
import api from "../../services/api";

const fmt = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
const MESES = ["Janeiro","Fevereiro","Marco","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
const hoje = new Date();

const STATUS_COR = {
  ORCAMENTO:"#6b7280",CONFIRMADO:"#1d4ed8",EM_PRODUCAO:"#92400e",
  PRONTO:"#065f46",ENTREGUE:"#15803d",CANCELADO:"#dc2626"
};
const STATUS_L = {
  ORCAMENTO:"Orcamento",CONFIRMADO:"Confirmado",EM_PRODUCAO:"Em Producao",
  PRONTO:"Pronto",ENTREGUE:"Entregue",CANCELADO:"Cancelado"
};

function Card({titulo, valor, sub, cor, icon}) {
  return(
    <div style={{background:"#fff",borderRadius:8,padding:"16px 20px",boxShadow:"0 1px 4px rgba(0,0,0,0.06)",display:"flex",flexDirection:"column",gap:4}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <span style={{fontSize:11,fontWeight:600,color:"var(--z-text-muted)",textTransform:"uppercase"}}>{titulo}</span>
        {icon&&<i className={"ti ti-"+icon} style={{fontSize:18,color:cor||"var(--z-text-muted)"}}/>}
      </div>
      <div style={{fontSize:22,fontWeight:700,color:cor||"var(--z-text-primary)"}}>{valor}</div>
      {sub&&<div style={{fontSize:12,color:"var(--z-text-muted)"}}>{sub}</div>}
    </div>
  );
}

export default function Dashboard() {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    api.get("/dashboard/").then(r=>setData(r.data)).finally(()=>setLoading(false));
  },[]);

  if(loading) return(
    <>
      <Topbar title="Dashboard"/>
      <div className="erp-content" style={{display:"flex",alignItems:"center",justifyContent:"center",height:300}}>
        <span style={{color:"var(--z-text-muted)"}}>Carregando...</span>
      </div>
    </>
  );

  if(!data) return null;

  const {vendas, financeiro, servicos, proximos_vencimentos, ultimos_pedidos} = data;

  return(
    <>
      <Topbar title="Dashboard"/>
      <div className="erp-content">
        <div style={{fontSize:13,color:"var(--z-text-muted)",marginBottom:16}}>
          {MESES[hoje.getMonth()]} {hoje.getFullYear()}
        </div>

        {/* Cards principais */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:20}}>
          <Card titulo="Vendas no Mes" valor={`R$ ${fmt(vendas.total_mes)}`} sub={`${vendas.qtd_pedidos} pedidos`} cor="var(--z-blue)" icon="shopping-cart"/>
          <Card titulo="A Receber" valor={`R$ ${fmt(financeiro.a_receber)}`} sub={financeiro.vencido_receber>0?`R$ ${fmt(financeiro.vencido_receber)} vencido`:null} cor="var(--z-success-text)" icon="cash"/>
          <Card titulo="A Pagar" valor={`R$ ${fmt(financeiro.a_pagar)}`} sub={financeiro.vencido_pagar>0?`R$ ${fmt(financeiro.vencido_pagar)} vencido`:null} cor={financeiro.vencido_pagar>0?"var(--z-danger-text)":"var(--z-warning-text)"} icon="credit-card"/>
          <Card titulo="OS em Aberto" valor={servicos.abertas} sub={`${servicos.agendadas} agendadas, ${servicos.em_execucao} em execucao`} cor="var(--z-blue)" icon="tools"/>
        </div>

        {/* Fluxo de caixa */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:20}}>
          <Card titulo="Entradas no Mes" valor={`R$ ${fmt(financeiro.entradas_mes)}`} cor="var(--z-success-text)" icon="trending-up"/>
          <Card titulo="Saidas no Mes" valor={`R$ ${fmt(financeiro.saidas_mes)}`} cor="var(--z-danger-text)" icon="trending-down"/>
          <Card titulo="Saldo do Mes" valor={`R$ ${fmt(financeiro.saldo_mes)}`} cor={financeiro.saldo_mes>=0?"var(--z-success-text)":"var(--z-danger-text)"} icon="scale"/>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20}}>
          {/* Status dos pedidos */}
          <div style={{background:"#fff",borderRadius:8,padding:16,boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
            <div style={{fontSize:13,fontWeight:600,marginBottom:12}}>Pedidos do Mes por Status</div>
            {Object.entries(vendas.por_status).filter(([,v])=>v>0).map(([s,v])=>(
              <div key={s} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:"1px solid var(--z-border)"}}>
                <span style={{fontSize:12,color:STATUS_COR[s],fontWeight:600}}>{STATUS_L[s]}</span>
                <span style={{fontSize:13,fontWeight:700}}>{v}</span>
              </div>
            ))}
            {Object.values(vendas.por_status).every(v=>v===0)&&(
              <div style={{fontSize:12,color:"var(--z-text-muted)",textAlign:"center",padding:"20px 0"}}>Nenhum pedido este mes</div>
            )}
          </div>

          {/* Proximos vencimentos */}
          <div style={{background:"#fff",borderRadius:8,padding:16,boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
            <div style={{fontSize:13,fontWeight:600,marginBottom:12}}>Proximos Vencimentos (7 dias)</div>
            {proximos_vencimentos.length===0&&(
              <div style={{fontSize:12,color:"var(--z-text-muted)",textAlign:"center",padding:"20px 0"}}>Nenhum vencimento proximo</div>
            )}
            {proximos_vencimentos.map((c,i)=>(
              <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 0",borderBottom:"1px solid var(--z-border)"}}>
                <div>
                  <div style={{fontSize:12,fontWeight:600}}>{c.descricao.slice(0,35)}{c.descricao.length>35?"...":""}</div>
                  <div style={{fontSize:11,color:c.status==="VENCIDO"?"var(--z-danger-text)":"var(--z-text-muted)"}}>
                    {new Date(c.vencimento+"T12:00:00").toLocaleDateString("pt-BR")} {c.status==="VENCIDO"?"— VENCIDO":""}
                  </div>
                </div>
                <span style={{fontSize:13,fontWeight:700,color:"var(--z-danger-text)"}}>R$ {fmt(c.valor)}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Ultimos pedidos */}
        <div style={{background:"#fff",borderRadius:8,padding:16,boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
          <div style={{fontSize:13,fontWeight:600,marginBottom:12}}>Ultimos Pedidos</div>
          <table style={{width:"100%",fontSize:12}}>
            <thead><tr style={{background:"var(--z-bg-page)"}}>
              <th style={{padding:"6px 8px",textAlign:"left"}}>#</th>
              <th style={{padding:"6px 8px",textAlign:"left"}}>Cliente</th>
              <th style={{padding:"6px 8px",textAlign:"left"}}>Data</th>
              <th style={{padding:"6px 8px",textAlign:"left"}}>Status</th>
              <th style={{padding:"6px 8px",textAlign:"right"}}>Total</th>
            </tr></thead>
            <tbody>
              {ultimos_pedidos.map(p=>(
                <tr key={p.id} style={{borderBottom:"1px solid var(--z-border)"}}>
                  <td style={{padding:"6px 8px",fontFamily:"monospace",color:"var(--z-text-muted)"}}>#{p.id}</td>
                  <td style={{padding:"6px 8px",fontWeight:600}}>{p.cliente}</td>
                  <td style={{padding:"6px 8px",color:"var(--z-text-secondary)"}}>{new Date(p.data_pedido+"T12:00:00").toLocaleDateString("pt-BR")}</td>
                  <td style={{padding:"6px 8px"}}>
                    <span style={{color:STATUS_COR[p.status],fontWeight:600}}>{STATUS_L[p.status]}</span>
                  </td>
                  <td style={{padding:"6px 8px",textAlign:"right",fontWeight:700}}>R$ {fmt(p.valor_total)}</td>
                </tr>
              ))}
              {ultimos_pedidos.length===0&&(
                <tr><td colSpan={5} style={{padding:"20px",textAlign:"center",color:"var(--z-text-muted)"}}>Nenhum pedido ainda</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
